'use client';

import { SidebarContent } from '@/components/layout/sidebar-content';
import { SilkSheet } from '@/components/ui/silk-sheet';
import { useLayoutStore } from '@/stores/layout';

export function MobileMenu(): React.ReactNode {
  const mobileMenuOpen = useLayoutStore((s) => s.mobileMenuOpen);
  const setMobileMenuOpen = useLayoutStore((s) => s.setMobileMenuOpen);

  function closeMenu(): void {
    setMobileMenuOpen(false);
  }

  function handleOpenChange(open: boolean): void {
    setMobileMenuOpen(open);
  }

  return (
    <SilkSheet
      open={mobileMenuOpen}
      onOpenChange={handleOpenChange}
      variant="side"
      side="right"
      title="Menu"
      description="Navigation menu"
      srOnlyHeader={true}
    >
      <SidebarContent onAfterAction={closeMenu} />
    </SilkSheet>
  );
}
